import CompanyModel from '@mm/state/model/CompanyModel';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import * as Yup from 'yup';
import { getPlanPrice } from '@mm/state/helpers/get-plan-price';
import { SessionObject } from '@mm/state/interfaces/session';

export type CheckoutFormValues = {
  email: string;
  firstName: string;
  lastName: string;
  country: string;
  terms: boolean;
  company?: number;
  address1: string;
  address2?: string;
  city: string;
  state?: string;
  postalCode: string;
};

const getInitialValues = (
  isTeam: boolean,
  company: CompanyModel,
  session: SessionObject,
) => {
  const initialValues: { [key: string]: any } = {
    email: session.email || '',
    firstName: session.firstName || '',
    lastName: session.lastName || '',
    country: 'US',
    state: 'Alabama',
    terms: false,
    address1: '',
    address2: '',
    city: '',
    postalCode: '',
  };

  if (isTeam) {
    initialValues.company = company.id;
  }

  return initialValues;
};

const fields = {
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  country: 'country',
  terms: 'terms',
  company: 'company',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
};

const getValidationSchema = (isTeam: boolean) => {
  const fields: { [key: string]: any } = {
    email: Yup.string()
      .email('Email field must be a valid email')
      .trim()
      .required('Email Required'),
    firstName: Yup.string().trim().required('First Name Required'),
    lastName: Yup.string().trim().required('Last Name Required'),
    country: Yup.string().required('Country Required'),
    address1: Yup.string().trim().required('Address Required'),
    city: Yup.string().trim().required('City Required'),
    state: Yup.string()
      .trim()
      .when('country', {
        is: 'US',
        then: Yup.string().trim().required('State Required'),
        otherwise: Yup.string().trim(),
      }),
    postalCode: Yup.string().trim().required('Zip Code Required'),
    // tslint:disable-next-line: max-line-length
    terms: Yup.boolean().oneOf([true], 'Must Accept Terms and Conditions'), // some issue with Formik, this error is never shown and FormProps.isValid:true despite checkbox value being false
  };

  if (isTeam) {
    fields.company = Yup.string().required('Company Required');
  }

  return Yup.object().shape(fields);
};

export const getProRatedAmount = (subscription?: SubscriptionModel) => {
  const priceFactor = subscription ? subscription.priceFactor : undefined;
  const coupon = subscription ? subscription.coupon : undefined;
  const price = subscription ? subscription.basePrice : undefined;

  if (priceFactor && price) {
    return priceFactor * getPlanPrice(price, coupon);
  }
};

const CheckoutFormHelpers = {
  getInitialValues,
  fields,
  getValidationSchema,
};

export default CheckoutFormHelpers;
